import * as React from "react";
const SvgFiBrandsCreativeCommonsSamplingPlus = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g
      fill="#151A2D"
      clipPath="url(#fi-brands-creative-commons-sampling-plus_svg__a)"
    >
      <path d="M11.985 0Q6.999 0 3.544 3.48 0 7.08 0 12q0 4.922 3.544 8.46Q7.089 24 11.985 24q4.956 0 8.591-3.57Q23.999 17.04 24 12t-3.484-8.52T11.985 0m.03 2.16q4.085 0 6.939 2.88 2.883 2.85 2.883 6.96 0 4.14-2.823 6.87-2.975 2.94-6.999 2.94-4.026 0-6.938-2.91-2.914-2.91-2.914-6.9t2.944-6.96q2.823-2.88 6.908-2.88" />
      <path d="M17.198 12.109a.56.56 0 0 0-.52.347l-.191.461-.534-4.492a.564.564 0 0 0-1.12.021l-.206 2.489-.252-3.331a.563.563 0 0 0-1.121-.002l-.17 2.174-.286-4.561a.563.563 0 0 0-1.123.001l-.247 4.05-.208-3.207a.562.562 0 0 0-1.122-.001l-.255 3.88-.2-2.756a.564.564 0 0 0-1.122-.007l-.375 4.345-.086-.591a.562.562 0 0 0-1.063-.16l-.637 1.34H4.234v1.124h2.48a.56.56 0 0 0 .502-.307l.52 3.538a.563.563 0 0 0 1.117-.033l.18-2.108.276 3.79a.562.562 0 0 0 1.122-.003l.225-3.408.23 3.549a.56.56 0 0 0 1.123-.003l.238-3.894.218 3.473a.563.563 0 0 0 1.12.008l.22-2.837.238 3.117a.56.56 0 0 0 1.119.004l.33-4.014.13 1.08a.561.561 0 0 0 1.077.149l.872-2.1h2.443V12.11zm-3.774.253h-1.062v1.062a.362.362 0 1 1-.725 0v-1.062h-1.061a.363.363 0 1 1 0-.724h1.06v-1.062a.363.363 0 0 1 .725 0v1.062h1.062a.362.362 0 0 1 0 .724" />
    </g>
    <defs>
      <clipPath id="fi-brands-creative-commons-sampling-plus_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiBrandsCreativeCommonsSamplingPlus;
